
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AppInputImage extends Vue {
    @Prop() public value!: object
    @Prop({ default: '' }) public error!: string

    get hasError() {
        return this.error && this.error.length > 0
    }

    public launchFilePicker() {
        (this.$refs.file as any).click()
    }

    public onFileChange(e: Event) {
        const { files } = e.target as any
        const maxSize = 1024 * 10
        const imageFile = files[0]

        if (files.length > 0) {
            const size = imageFile.size / maxSize / maxSize
            if (!imageFile.type.match(/image\/(png|jpg|jpeg)/)) {
                window.alert(
                    'Por favor, escolha um arquivo de imagem jpg ou png',
                )
            } else if (size > 1) {
                window.alert(
                    'Seu arquivo é muito grande! Selecione uma imagem com menos de 10 MB',
                )
            } else {
                const imageURL = URL.createObjectURL(imageFile)

                this.$emit('input', { imageURL, file: imageFile })
            }
        }
    }
}
